import React, { useState, useEffect, useRef } from 'react';
import { FaGlobe, FaTimes } from 'react-icons/fa';

const TranslateWidget = () => {
  const [showTranslate, setShowTranslate] = useState(false);
  const panelRef = useRef(null);

  const handleToggle = () => {
    setShowTranslate((prev) => !prev);
  };

  useEffect(() => {
    // Load Google Translate script
    const addGoogleTranslateScript = () => {
      if (!document.getElementById('google-translate-script')) {
        const script = document.createElement('script');
        script.id = 'google-translate-script';
        script.src =
          'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
        script.async = true;
        document.body.appendChild(script);
      }
    };

    // Initialize Google Translate
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        'google_translate_element'
      );
    };

    addGoogleTranslateScript();
  }, []);

  // Close when clicking anywhere outside the panel or pill
  useEffect(() => {
    if (!showTranslate) return undefined;
    const handleOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setShowTranslate(false);
      }
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [showTranslate]);

  return (
    <div ref={panelRef}>
      {/* Language Selector Button */}
      <button
        type='button'
        aria-label='Translate this page'
        aria-expanded={showTranslate}
        className='fixed top-3 right-4 flex items-center space-x-2 bg-gray-800 text-white rounded-full px-3 py-2 shadow-lg cursor-pointer z-[60] border border-gray-50 hover:bg-gray-700 transition-colors'
        onClick={handleToggle}
      >
        <span className='text-sm font-medium'>EN</span>
        <FaGlobe size={16} />
      </button>

      {/* Google Translate Widget — fixed panel anchored under the pill,
          kept fully on-screen with a viewport-relative max width */}
      <div
        className={`${
          showTranslate ? 'block' : 'hidden'
        } fixed top-16 right-4 max-w-[calc(100vw-2rem)] w-64 bg-white rounded-lg p-4 z-[60] shadow-xl border border-gray-200`}
      >
        <div className='flex items-center justify-between mb-2'>
          <p className='text-xs font-semibold text-gray-500 uppercase tracking-wider'>
            Translate this page
          </p>
          <button
            type='button'
            aria-label='Close translation panel'
            onClick={() => setShowTranslate(false)}
            className='text-gray-400 hover:text-gray-600'
          >
            <FaTimes size={14} />
          </button>
        </div>
        <div id='google_translate_element' />
      </div>
    </div>
  );
};

export default TranslateWidget;
